<template>
  <div class="w-100 row  mt-4">
      <div class="w-100 p-cup-map-items row">
            <div v-for="data in locationData.locations" :key="data.id" class="w-100 p-cup-map-item row align-items-center mb-3">
                  <div @click="removeLocation(data)" class="p-cup-map-close">
                    <img class="p-cup-map-icon-close" src="../../assets/svg/close.svg" alt="">
                  </div>
                  <div class="p-cup-map-box-item d-flex mr-3 align-items-center">
                    <h3 class="p-cup-map-item-title ml-2 ">{{data.title}}</h3>
                    <img class="p-cup-map-item-place-icon" src="../../assets/svg/pin.svg" alt="">
                  </div>
            </div>


      </div>

        <div class="d-flex align-items-center mb-4  p-edit-representation-form-item align-items-center">
            <label class="ml-4 mb-2 mb-lg-0 p-edit-representation-form-text"> نام جام </label>
            <div class="col-lg-8 d-flex align-items-center">
              <input type="text" v-model="titleLocation" placeholder="" class="form-control text-right  pr-3 pl-2 pr-2">
            </div>
        </div>
  </div>
</template>

<script>


export default {
  name: "itemMap",
  components: {
  },

  props: {
    valueTitleLocation   : {type:[String],default:''},
    locationData         : {type:[Array,Object],default:[]},
  },


  data() {
    return {
      titleLocation : '',
    }
  },

  watch: {
    titleLocation(value){
      this.$emit('titleLocation',value);
    },

    valueTitleLocation(value){
      this.titleLocation = value;
    },

    locationData(data){
      console.log(data,'locationData');
    }

  },

  created() {

  },

  mounted() {

  },

  methods: {
    removeLocation(data){
      this.$emit('removeLocation',data);
    }

  }


}
</script>
